import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as S from './Toggle.styles.tsx';
import P from '../texts/p/P.tsx';

const Toggle = ({
  disabled,
  checked,
  onChange,
  size,
  leftText,
  rightText,
  onClick,
  id,
}) => {
  const [isChecked, setChecked] = useState(checked);

  useEffect(() => {
    setChecked(checked);
  }, [checked]);

  const handleChange = ({ target: { checked } }) => {
    if (onChange) {
      setChecked(checked);
      onChange(checked);
    }
  };

  const handleClick = ({ target: { checked } }) => {
    onClick && onClick(checked);
  };

  return (
    <S.Toogle>
      <S.ToogleWrapper disabled={disabled}>
        <P variant='neutral' modifier='strong'>
          {leftText}
        </P>
        <S.ToogleSwitch size={size}>
          <S.ToogleCheckbox
            disabled={disabled}
            checked={isChecked}
            onChange={handleChange}
            onClick={handleClick}
          />
          <S.Switch size={size} />
        </S.ToogleSwitch>
        <P variant='neutral' modifier='strong'>
          {rightText}
        </P>
      </S.ToogleWrapper>
    </S.Toogle>
  );
};

Toggle.defaultProps = {
  disabled: false,
  checked: false,
  size: 'sm',
  leftText: '',
  rightText: '',
};

Toggle.propTypes = {
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  leftText: PropTypes.string,
  rightText: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md']),
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  id: PropTypes.string,
};

export default Toggle;
